import React from 'react';
import DropdownItem from '@/components/DropdownItem';
import ToolsMenu from '@/components/tools/ToolsMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const NotificationTools = ({
  category,
  code,
  event,
  notificationCode,
  upward,
  listItem = false,
}) => {
  const { allowRead } = Selectors.useNotificationTools();
  const show = Events.useShowNotification(category, { code });

  return (
    <ToolsMenu listItem={listItem} upward={upward}>
      {allowRead && (
        <DropdownItem icon="bell" textId="actions.open" onClick={() => show({ event, notificationCode })} />
      )}
    </ToolsMenu>
  );
};

export default NotificationTools;
